import React, { Component, Fragment } from 'react';
import api from '../../../services/api';
import './styles.css';

class LoginForgot extends Component {

    state = {
        load: false,
        statusPost: false,
        statusPostError: false
    }

    componentDidMount() {

        if (localStorage.getItem('UserTypeId') != 2) {
            window.location.href = window.location.origin;
        }

    }

    resetPassword = async () => {

        const password = document.getElementById('password').value;
        const password2 = document.getElementById('password2').value;
        if (password != password2) {
            this.setState({ statusPostError: 'Erro. Digite senha iguais!' });
        } else {
            this.setState({ load: true });
            await api.post(`/auth/request-reset-password`, {
                email: localStorage.getItem('email')
            }).then(async (result) => {
                if (result && result.data) {

                    await api.put(`/auth/user/${result.data.hash}`, {
                        password: password
                    }).then((result) => {
                        if (result && result.data) {
                            this.setState({ statusPost: result.data.msg, load: false, statusPostError: null });
                            document.getElementById('password').value = '';
                            document.getElementById('password2').value = '';
                        } else {
                            this.setState({ statusPostError: 'Erro. Tente novamente!', load: false });
                        }
                    }).catch(error => {
                        let errors = error.response.data;
                        this.setState({ statusPostError: (errors.msg) ? errors.msg : errors.errors[0].msg, load: false });
                    });

                } else {
                    this.setState({ statusPostError: 'Erro. Tente novamente!', load: false });
                }
            }).catch(error => {
                let errors = error.response.data;
                this.setState({ statusPostError: (errors.msg) ? errors.msg : errors.errors[0].msg, load: false });
            });
        }
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Alterar a Senha
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <form action="javascript:void(0)" id="formCompany">
                    {(!this.state.hash) ?
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <h5>Digite a nova senha</h5>
                                    <input type="password" id="password" className='form-control form-control-success' />
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <h5>Repetir a nova senha</h5>
                                    <input type="password" id="password2" className='form-control form-control-success' />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <button disabled={this.state.load} onClick={this.resetPassword} className="btn btn-success"> <i className="fa fa-check"></i> Alterar senha</button>
                                <br /><br />
                            </div>

                            <div className="col-md-12">

                                {(this.state.statusPost) ?
                                    <div className="alert alert-success">
                                        {this.state.statusPost}
                                    </div>
                                    : null}

                                {(this.state.statusPostError) ?
                                    <div className="alert alert-danger">
                                        {this.state.statusPostError}
                                    </div>
                                    : null}
                            </div>
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <h5>Digite sua nova senha</h5>
                                    <input type="password" id="password" className='form-control form-control-success' />
                                    <br /><br />
                                    <button disabled={this.state.load} onClick={this.changePasswordOk} className="btn btn-success"> <i className="fa fa-check"></i> Alterar</button>
                                </div>
                            </div>

                            <div className="col-md-12">
                                {(this.state.statusPost) ?
                                    <div className="alert alert-success">
                                        {this.state.statusPost}
                                    </div>
                                    : null}

                                {(this.state.statusPostError) ?
                                    <div className="alert alert-danger">
                                        {this.state.statusPostError}
                                    </div>
                                    : null}
                            </div>
                        </div>
                    }
                </form>

            </Fragment >
        )
    }

}

export default LoginForgot;